export default __webpack_public_path__ + "static/media/signing-paper-mobile.f686b510.jpg";